import React from 'react';

const SyncUpProductContext = React.createContext();

export default SyncUpProductContext;
